import React, { useContext, useEffect, useState } from "react";
import classes from "./Header.module.css";
import logoWhite from "../../assets/logo/white.png";
import logoBlack from "../../assets/logo/black.png";
import { Link, animateScroll as scroll } from "react-scroll";

import { debounce } from "../../utilities/helpers";

import Nav from "./nav/Nav";
import { ThemeContext } from "../../ThemeProvider";
import NavMobile from "./nav/NavMobile";

import { motion } from "framer-motion";

const Header = () => {
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(false);

  const { dark } = useContext(ThemeContext);

  const header_classname = () => {
    if (!dark && visible) {
      return classes.header__visible;
    } else if (dark && visible) {
      return classes.header__visible__dark;
    } else if (!dark && !visible) {
      return classes.header;
    } else if (dark && !visible) {
      return classes.header__dark;
    }
  };

  const handleScroll = debounce(() => {
    const currentScrollPos = window.pageYOffset;

    setVisible(
      (prevScrollPos > currentScrollPos &&
        prevScrollPos - currentScrollPos > 70) ||
        currentScrollPos < 10
    );

    if (currentScrollPos === 0) {
      setVisible(false);
    }

    setPrevScrollPos(currentScrollPos);
  }, 100);

  useEffect(() => {
    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, [prevScrollPos, visible, handleScroll]);

  const animateFrom = { opacity: 0, y: -40 };
  const animateTo = { opacity: 1, y: 0 };

  return (
    <header className={header_classname()}>
      <motion.div
        className={classes.header__left}
        initial={animateFrom}
        animate={animateTo}
        transition={{ delay: 0.01, duration: 0.5, type: "tween" }}
      >
        <Link
          to="/"
          className={classes.header__logo__container}
          onClick={() => scroll.scrollToTop()}
        >
          {dark ? (
            <img src={logoWhite} alt="logo-white" className={classes.logo} />
          ) : (
            <img src={logoBlack} alt="logo-black" className={classes.logo} />
          )}
        </Link>
      </motion.div>
      <div className={classes.header__right}>
        <Nav customClass={classes.nav} />
        <NavMobile customClass={classes.nav__mobile} />
      </div>
    </header>
  );
};

export default Header;
